import { render, staticRenderFns } from "./barcode-renderer.vue?vue&type=template&id=517c9168&"
import script from "./barcode-renderer.vue?vue&type=script&lang=js&"
export * from "./barcode-renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports